import { ModalContextType } from "@/lib/main";
import { createContext } from "react";

const ModalContext = createContext<ModalContextType | null>(null);

export default ModalContext;
